<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <b-container>
      <b-row align-v="center">
        <b-col cols="auto">
          <v-btn class="btn-return" @click="$router.go(-1)">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i>
            VOLTAR
          </v-btn>
        </b-col>
        <b-col>
          <h1 class="title-pages">
            CONFIGURAÇÃO IMPORTAÇÃO DE PRODUTOS DA NOTA FISCAL NA COMPRA
          </h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card title="">
            <div class="row">
              <div class="col-md-12">
                <label
                  >MANTER O NOME DO PRODUTO DA NOTA FISCAL, OU ALTERAR PARA O
                  NOME QUE JÁ ESTIVER CADASTRADO</label
                >
                <select v-model="nfe_change_name_item" class="form-control">
                  <option value="NAO">
                    MANTER O NOME DO PRODUTO DA NOTA FISCAL
                  </option>
                  <option value="SIM">
                    ALTERAR PARA O NOME QUE JÁ ESTIVER CADASTRADO
                  </option>
                </select>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <errors-messages :errors="errors" />
      <b-row align-h="end">
        <b-col cols="auto">
          <confirmation-dialog
            message-title="CONFIRMAÇÃO"
            message-body="TEM CERTEZA QUE DESEJA SALVAR?"
            open-class="btn-save"
            open-text="SALVAR"
            openLeftIcon="fa-check"
            @yes="save"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import ErrorsMessages from "../templates/Components/ErrorsMessages";
import ConfirmationDialog from "../templates/Components/ConfirmationDialog";

import api from "../services/api";

import toast from "../lib/ToastNotification";

export default {
  name: "NfeChangeNameItem",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    ConfirmationDialog,
  },

  data() {
    return {
      errors: [],
      nfe_change_name_item: "NAO",
      loading: false,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    async retrieve() {
      await this.get();
    },

    async get() {
      this.loading = true;

      const response = await api.get("/rest-home/settings/nfe");

      const { error, errors, nfe_change_name_item } = response.data;

      if (error) {
        this.errors = errors;
      } else {
        this.errors = [];
        this.nfe_change_name_item = nfe_change_name_item == 1 ? "SIM" : "NAO";
      }
    },

    async save() {
      try {
        this.loading = true;

        let { nfe_change_name_item } = this;

        if (nfe_change_name_item == "SIM") {
          nfe_change_name_item = 1;
        } else {
          nfe_change_name_item = null;
        }

        const data = { nfe_change_name_item };

        const response = await api.patch("/rest-home/settings/nfe", data);

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message);
          this.retrieve();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
